module.exports = __webpack_public_path__ + "img/replace_mob.828cb67b.svg";